import { Component, inject, OnInit, ChangeDetectorRef } from '@angular/core';
import { AppStateService } from '../../services/app-state.service';
import { ExternalLiquidityService } from '../../services/external-liquidity.service';

@Component({
  selector: 'app-ecosystem-hub',
  standalone: true,
  templateUrl: './ecosystem-hub.component.html'
})
export class EcosystemHubComponent implements OnInit {
  public state = inject(AppStateService);
  private externalService = inject(ExternalLiquidityService);
  private cdr = inject(ChangeDetectorRef);

  bnbStats = { tvl: '$0.00', vol: '$0.00' };
  ethStats = { tvl: '$0.00', vol: '$0.00' };
  polygonStats = { tvl: '$0.00', vol: '$0.00' };
  platformStats = { tvl: '$0.00', vol: '$0.00', pools: 0, users: '10,000+' };

  ngOnInit() {
    this.fetchData();
  }

  async fetchData() {
    try {
      const [bnb, eth, poly, all] = await Promise.all([
        this.externalService.getOverview('56'),
        this.externalService.getOverview('1'),
        this.externalService.getOverview('137'),
        this.externalService.getOverview()
      ]);

      this.bnbStats = { tvl: this.formatNumber(bnb.totalTvl), vol: this.formatNumber(bnb.totalVolume24h) };
      this.ethStats = { tvl: this.formatNumber(eth.totalTvl), vol: this.formatNumber(eth.totalVolume24h) };
      this.polygonStats = { tvl: this.formatNumber(poly.totalTvl), vol: this.formatNumber(poly.totalVolume24h) };

      this.platformStats = {
        tvl: this.formatNumber(all.totalTvl),
        vol: this.formatNumber(all.totalVolume24h),
        pools: all.totalPools,
        users: '10,000+'
      };
      this.cdr.detectChanges();
    } catch (e) {
      console.error('Failed to fetch overview stats', e);
    }
  }

  formatNumber(num: number): string {
    if (num >= 1e9) return '$' + (num / 1e9).toFixed(2) + 'B+';
    if (num >= 1e6) return '$' + (num / 1e6).toFixed(2) + 'M+';
    if (num >= 1e3) return '$' + (num / 1e3).toFixed(2) + 'K+';
    return '$' + num.toFixed(2);
  }
}
